import ApiClient from '@afosto/api/ApiClient';

class Tenants {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a new tenant
   *
   * @param {Object} body - Signup object
   * @param {Object} options - The additional request options
   * @description Returns a new authorization response
   * @returns {Promise}
   */
  createTenant(body, options = {}) {
    return this.apiClient.request({
      url: `/iam/tenants`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Get a info about tenant
   *
   * @param {string} id - Id that belongs to the tenant
   * @param {Object} options - The additional request options
   * @description Return the current tenant information
   * @returns {Promise}
   */
  getTenant(id, options = {}) {
    return this.apiClient.request({
      url: `/iam/tenants/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Request token
   *
   * @param {Object} body - Purge request
   * @param {Object} options - The additional request options
   * @description Requests a purge token
   * @returns {Promise}
   */
  requestPurgeToken(body, options = {}) {
    return this.apiClient.request({
      url: `/iam/purges`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Apply token
   *
   * @param {string} token
   * @param {Object} options - The additional request options
   * @description Start purge for token
   * @returns {Promise}
   */
  startPurge(token, options = {}) {
    return this.apiClient.request({
      url: `/iam/purges/${token}`,
      method: 'post',
      ...options,
    });
  }

  /**
   * Update company name
   *
   * @param {string} id - Id that belongs to the tenant
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update the company name
   * @returns {Promise}
   */
  updateCompanyName(id, body, options = {}) {
    return this.apiClient.request({
      url: `/iam/tenants/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * View token
   *
   * @param {string} token
   * @param {Object} options - The additional request options
   * @description View a purge token
   * @returns {Promise}
   */
  viewPurgeToken(token, options = {}) {
    return this.apiClient.request({
      url: `/iam/purges/${token}`,
      method: 'get',
      ...options,
    });
  }
}

export const tenants = new Tenants();

export default Tenants;
